/**
 * Created by Alex Poh. on 26/05/20.
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */

import { TermsOfUsePageComponent } from './terms-of-use-page/terms-of-use-page.component';
import { PrivacyPolicyPageComponent} from './privacy-policy-page/privacy-policy-page.component';

export const sharedStaticPages = [
  { path: 'terms-of-service', component: TermsOfUsePageComponent },
  { path: 'private-policy', component: PrivacyPolicyPageComponent },
];
